/**
 * This filters a list of classrooms by grade_level and name
 * If grade search term is undefined then grade_level filtering is skipped
 * If name search term is undefined then name filtering is skipped
 * If grade_level is not defined for a classroom then the classroom is passed
 */
angular.module('rightPaneModule')
.filter('ClassroomGradeLevelFilter', [function() {
    function isMatch(item, grade, search) {
        if (grade && item.grade_level && grade !== item.grade_level) {
            return false;
        }

        if (search && item.name.toLowerCase().indexOf(search) < 0) {
            return false;
        }

        return true;
    }
    return function(items, grade, search) {
        var out = [];
        search = search ? search.toLowerCase() : null;
        if (angular.isArray(items)) {
            items.forEach(function(item) {
                if (isMatch(item, grade, search)) {
                    out.push(item);
                }
            });
        } else {
            out = items;
        }
        return out;
    };
}]);
